export const FreemiumUpgradeENUSTranslations = {
  freemiumUpgradePageHeadTitle: 'Falar com vendas | 4intellingence',
  freemiumUpgradePageHeadDescription:
    'Tire suas dúvidas conosco. Fale com nossos especialistas',
  freemiumUpgradePageTitle:
    'Contate nosso time de vendas e saiba mais sobre como podemos ajudar seu negócio!',
  freemiumUpgradePageDescription:
    'Fale conosco pelo Whatsapp ou preencha o formulário abaixo.',
  freemiumUpgradePageWhatsappButton: 'Falar pelo Whatsapp',
};
